import clsx from 'clsx'
import { IBreadcrumbsProps, TBreadcrumbItem } from './types'
import styles from './styles.module.scss'

const Breadcrumbs = ({
  className,
  id,
  items,
  onClick,
  separator,
  preventDefaultOnClick = false,
  size = 'md',
  style,
  truncate = { length: 130 },
  ...props
}: IBreadcrumbsProps) => {
  return (
    <nav
      className={clsx('mui-breadcrumbs', styles.breadcrumbs, {
        [styles.listTruncate]: Boolean(truncate),
      })}
      data-testid="mui-breadcrumbs"
      id={id}
      aria-label="Breadcrumb"
      style={style}
      {...props}
    >
      <ul className={`${styles.ul} ${styles[size]}`}>
        {items.map((breadcrumb: TBreadcrumbItem, i) => {
          const itemTruncate = breadcrumb.truncate ? breadcrumb.truncate : truncate
          const itemTruncateLength =
            breadcrumb?.truncate && breadcrumb.truncate.length
              ? `${breadcrumb.truncate.length}px`
              : truncate && truncate.length
                ? `${truncate.length}px`
                : `100%`

          return (
            <li
              className={`${styles.breadcrumb} ${styles[size]} ${className ? className : ''}`}
              key={i}
            >
              {i === items.length - 1 ? (
                <span
                  className={styles.lastItem}
                  id={`breadcrumb-${breadcrumb.id}-${i}`}
                  key={`key-${breadcrumb.id}-${i}`}
                  aria-current="page"
                >
                  {breadcrumb?.icon && <div className={styles.before}>{breadcrumb?.icon}</div>}
                  <span
                    className={`${itemTruncate ? styles.truncate : ''}`}
                    style={{
                      maxWidth: itemTruncateLength,
                    }}
                  >
                    {breadcrumb.label}
                  </span>
                </span>
              ) : (
                <a
                  id={`breadcrumb-${breadcrumb.id}-${i}`}
                  key={`key-${breadcrumb.id}-${i}`}
                  href={breadcrumb.path}
                  onClick={(e) => {
                    if (preventDefaultOnClick) {
                      e.preventDefault()
                    }
                    if (onClick) {
                      onClick(breadcrumb.id)
                    }
                  }}
                  style={{
                    cursor: 'pointer',
                  }}
                >
                  {breadcrumb?.icon && <div className={styles.before}>{breadcrumb?.icon}</div>}
                  <span
                    className={`${itemTruncate ? styles.truncate : ''}`}
                    style={{
                      maxWidth: itemTruncateLength,
                    }}
                  >
                    {breadcrumb.label}
                  </span>
                </a>
              )}
              <div className={styles.separator}>
                {separator ? (
                  separator
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512">
                    <path d="M308.1 3.3c11.4 6.7 15.3 21.4 8.6 32.8l-272 464c-6.7 11.4-21.4 15.3-32.8 8.6S-3.4 487.3 3.3 475.9l272-464C282 .4 296.7-3.4 308.1 3.3z" />
                  </svg>
                )}
              </div>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}

export default Breadcrumbs
